import React, { useEffect, useState } from "react";
import '../index.css';
import logo from '../assets/giffypedialogo.png';
import { useNavigate, Link, NavLink } from "react-router-dom"; 
import Userprofile from '../assets/userprofile.png';
import Dropdown from "./Dropdown";
import { FaChevronDown } from "react-icons/fa";
import { RxHamburgerMenu, RxCross2 } from "react-icons/rx";
import { AiOutlineLogin, AiOutlineUserAdd } from "react-icons/ai";

function Header() {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [userProfileType, setUserProfileType] = useState("");
  const [userCompanyName, setUserCompanyName] = useState("");
  const [userAvatar, setUserAvatar] = useState(Userprofile);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const loginStatus = localStorage.getItem('isLoggedIn') === 'true';
    setIsLoggedIn(loginStatus);
    const storedName = localStorage.getItem('user_name');
    const storedAvatar = localStorage.getItem('avatar');
    const storedProfileType = localStorage.getItem('profile_type');
    const storedCompanyName = localStorage.getItem('company_name');

    if (storedName) setUserName(storedName);
    if (storedAvatar) setUserAvatar(`https://www.giffypedia.com/uploads/${storedAvatar}`);
    if (storedProfileType) setUserProfileType(storedProfileType);
    if (storedCompanyName) setUserCompanyName(storedCompanyName);

    // If user is logged in but we don't have profile data, fetch it
    if (loginStatus && !storedProfileType) {
      fetchUserProfileData();
    }

    const updateLoginStatus = () => {
      const updatedStatus = localStorage.getItem('isLoggedIn') === 'true';
      setIsLoggedIn(updatedStatus);
      setUserName(localStorage.getItem('user_name') || "");
      const updatedAvatar = localStorage.getItem('avatar');
      if (updatedAvatar) setUserAvatar(`https://www.giffypedia.com/uploads/${updatedAvatar}`);
      
      const updatedProfileType = localStorage.getItem('profile_type');
      const updatedCompanyName = localStorage.getItem('company_name');
      if (updatedProfileType) setUserProfileType(updatedProfileType);
      if (updatedCompanyName) setUserCompanyName(updatedCompanyName);
      
      // If user just logged in, fetch their profile data
      if (updatedStatus && !updatedProfileType) {
        fetchUserProfileData();
      }
    };

    const handleProfilePictureUpdate = (event) => {
      const newAvatar = event.detail?.avatar;
      if (newAvatar) {
        setUserAvatar(`https://www.giffypedia.com/uploads/${newAvatar}`);
        localStorage.setItem('avatar', newAvatar);
      }
    };

    window.addEventListener("userLogin", updateLoginStatus);
    window.addEventListener("userLogout", updateLoginStatus);
    window.addEventListener("profilePictureUpdated", handleProfilePictureUpdate);

    return () => {
      window.removeEventListener("userLogin", updateLoginStatus);
      window.removeEventListener("userLogout", updateLoginStatus);
      window.removeEventListener("profilePictureUpdated", handleProfilePictureUpdate);
    };
  }, []);

  const fetchUserProfileData = () => {
    const userId = localStorage.getItem('user_id');
    if (!userId) return;
    
    fetch("/php-api/get-user.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: userId }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const userData = data.user;
          // Store profile type and company name in localStorage
          localStorage.setItem('profile_type', userData.profile || '');
          localStorage.setItem('company_name', userData.companyname || '');
          
          setUserProfileType(userData.profile || '');
          setUserCompanyName(userData.companyname || '');
        }
      })
      .catch(error => {
        console.error("Error fetching user profile:", error);
      });
  };

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('profile_type');
    localStorage.removeItem('company_name');
    window.dispatchEvent(new Event("userLogout"));
    navigate("/");
  };

  // Determine what name to display
  const displayName = userProfileType === "professional" && userCompanyName 
    ? userCompanyName 
    : userName;

  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-2">
          <img src={logo} alt="Giffypedia Logo" className="h-10" />
        </Link>

        {/* Hamburger for mobile */}
        <button
          className="lg:hidden text-xl text-primarycolor focus:outline-none"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? (
            <RxCross2 className="w-6 h-6" />
          ) : (
            <RxHamburgerMenu className="w-6 h-6" />
          )}
        </button>

        {/* Navigation Links - Desktop */}
        <div className="hidden lg:flex gap-8">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive
                ? "text-primarycolor font-bold border-b-2 border-primarycolor px-3 py-2"
                : "text-gray-700 hover:text-primarycolor px-3 py-2"
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive
                ? "text-primarycolor font-bold border-b-2 border-primarycolor px-3 py-2"
                : "text-gray-700 hover:text-primarycolor px-3 py-2"
            }
          >
            About Us
          </NavLink>
          <NavLink
            to="/verifyprofile"
            className={({ isActive }) =>
              isActive
                ? "text-primarycolor font-bold border-b-2 border-primarycolor px-3 py-2"
                : "text-gray-700 hover:text-primarycolor px-3 py-2"
            }
          >
            Verify your Profile
          </NavLink>
          <NavLink
            to="/advertisement"
            className={({ isActive }) =>
              isActive
                ? "text-primarycolor font-bold border-b-2 border-primarycolor px-3 py-2"
                : "text-gray-700 hover:text-primarycolor px-3 py-2"
            }
          >
            Advertisement
          </NavLink>
            <NavLink
            to="/news"
            className={({ isActive }) =>
              isActive
                ? "text-primarycolor font-bold border-b-2 border-primarycolor px-3 py-2"
                : "text-gray-700 hover:text-primarycolor px-3 py-2"
            }
          >
            News
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive
                ? "text-primarycolor font-bold border-b-2 border-primarycolor px-3 py-2"
                : "text-gray-700 hover:text-primarycolor px-3 py-2"
            }
          >
            Contact
          </NavLink>
        </div>

        {/* Right: Login / Avatar */}
        <div className="flex items-center space-x-4">
          {isLoggedIn ? (
            <div className="flex items-center space-x-2">
              <Dropdown
                label={
                  <span className="flex items-center text-gray-800 hover:text-[#ef4836] cursor-pointer">
                   <span className="text-overflow-headerprofile">{displayName}</span>
                    <FaChevronDown className="w-4 h-4 ml-2"/>
                     
                  </span>
                }
                items={[
                  { label: "My Profile", href: "/my-profile" },
                  { label: "Change Password", href: "/ChangePassword" },
                  { label: "Logout", onClick: handleLogout },
                ]}
              />
              <img
                src={userAvatar}
                alt="Avatar"
                className="h-9 w-9 rounded-full border border-gray-300 object-cover"
              />
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <Link to="/login" className="text-gray-800 hover:text-[#ef4836] font-medium flex items-center gap-2">
               <AiOutlineLogin /> Login
              </Link>
              <span className="text-gray-400">|</span>
              <Link to="/register" className="text-gray-800 hover:text-[#ef4836] font-medium flex items-center gap-2">
               <AiOutlineUserAdd /> Register
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 z-50 bg-black bg-opacity-40 flex">
          <div className="bg-white shadow-lg w-64 h-full p-4 flex flex-col gap-6 animate-slide-in">
            <div className="flex items-center justify-between">
              <Link to="/" onClick={() => setMobileMenuOpen(false)}>
                <img src={logo} alt="Giffypedia Logo" className="h-10" />
              </Link>
              <button
                className="text-xl text-primarycolor"
                onClick={() => setMobileMenuOpen(false)}
                aria-label="Close menu"
              >
                <RxCross2 className="w-6 h-6" />
              </button>
            </div>
            <nav className="flex flex-col gap-4">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive
                    ? "text-primarycolor font-bold border-l-4 border-primarycolor bg-gray-100 px-4 py-2 rounded"
                    : "text-gray-700 hover:text-primarycolor px-4 py-2 rounded"
                }
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </NavLink>
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  isActive
                    ? "text-primarycolor font-bold border-l-4 border-primarycolor bg-gray-100 px-4 py-2 rounded"
                    : "text-gray-700 hover:text-primarycolor px-4 py-2 rounded"
                }
                onClick={() => setMobileMenuOpen(false)}
              >
                About Us
              </NavLink>
              <NavLink
                to="/verifyprofile"
                className={({ isActive }) =>
                  isActive
                    ? "text-primarycolor font-bold border-l-4 border-primarycolor bg-gray-100 px-4 py-2 rounded"
                    : "text-gray-700 hover:text-primarycolor px-4 py-2 rounded"
                }
                onClick={() => setMobileMenuOpen(false)}
              >
                Verify your Profile
              </NavLink>
              <NavLink
                to="/advertisement"
                className={({ isActive }) =>
                  isActive
                    ? "text-primarycolor font-bold border-l-4 border-primarycolor bg-gray-100 px-4 py-2 rounded"
                    : "text-gray-700 hover:text-primarycolor px-4 py-2 rounded"
                }
                onClick={() => setMobileMenuOpen(false)}
              >
                Advertisement
              </NavLink>
                  <NavLink
                to="/news"
                className={({ isActive }) =>
                  isActive
                    ? "text-primarycolor font-bold border-l-4 border-primarycolor bg-gray-100 px-4 py-2 rounded"
                    : "text-gray-700 hover:text-primarycolor px-4 py-2 rounded"
                }
                onClick={() => setMobileMenuOpen(false)}
              >
                News
              </NavLink>
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  isActive
                    ? "text-primarycolor font-bold border-l-4 border-primarycolor bg-gray-100 px-4 py-2 rounded"
                    : "text-gray-700 hover:text-primarycolor px-4 py-2 rounded"
                }
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </NavLink>
            </nav>
          </div>
          <div className="flex-1" onClick={() => setMobileMenuOpen(false)} />
        </div>
      )}
    </header>
  );
}

export default Header;